import React, {useMemo} from 'react';
import {Table, Button, Dropdown, Input} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {invoicesPageSizes} from '../../../common/constants/lists';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import moment from 'moment';


export const Filter = ({column}) => {
  return (
    <div>
      {column.canFilter && column.render('Filter')}
    </div>
  );
};

export const DefaultColumnFilter = ({
  'column': {
    filterValue,
    setFilter,
  },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || null);
      }}
    />
  );
};


const EtaManagementTable = ({tableColumns, tableData, selection}) => {
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, []);
  /* const [showFechaFacturaModal, setShowFechaFacturaModal] = useState(false); */

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': () => null},
      'initialState': {'pageIndex': 0, 'pageSize': 50},
      'autoResetFilters': false,
      'autoResetPage': false,
    },
    useFilters,
    usePagination,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        /* {
          'id': 'processCheckBox',
          'Header': '',
          'width': 1,
          'defaultCanFilter': true,
          'Cell': ({row}) => {
            return (
              <div> Action</div>
            );
          },
          'Filter': () => null,
        }, */
        ...columns
          .map((col) => {
            if (['order_date', 'tde_process_date', 'abis_process_date', 'next_abis_etd',
              'last_abis_ship_date', 'eta_standard_date', 'eta_updated_date'].includes(col.id)) {
              return {...col,
                'Cell': ({row, value}) => {
                  return (
                    <>{value && moment(value).format(dateFormatShow)}</>
                  );
                },
              };
            }
            return {...col};
          }),
      ]);
    },
  );

  return (
    <>
      <div style={{'overflow': 'auto', 'position': 'relative', 'maxHeight': '450px'}}>
        <Table width='13' className='full-table' compact striped {...getTableProps()}>
          <Table.Header className='commercial-sticky-header eta-table-fixed' style={{'fontSize': '90%'}}>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  ['abis_status', 'abis_lines_qty', 'abis_process_date', 'ord_qty',
                    'prc_qty', 'cancel_qty', 'shipped_qty', 'next_abis_etd'].includes(column.id) ?
                    <Table.HeaderCell
                      key={`title-${index}`}
                      textAlign='center'
                      style={{'background': 'black', 'color': 'white'}}
                      {...column.getHeaderProps()}
                    >
                      {column.render('Header')}
                    </Table.HeaderCell> :
                    ['days_from_order', 'days_from_abis_process', 'warning'].includes(column.id) ?
                      <Table.HeaderCell
                        key={`title-${index}`}
                        textAlign='center'
                        style={{'background': '#FF66FF', 'color': 'black'}}
                        {...column.getHeaderProps()}
                      >
                        {column.render('Header')}
                      </Table.HeaderCell> :
                      <Table.HeaderCell
                        key={`title-${index}`}
                        textAlign='center'
                        {...column.getHeaderProps()}
                      >
                        {column.render('Header')}
                      </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={20} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                const status = row.original.warning;

                if (row.original.follow_percentage === 1) {
                  return (
                    <Table.Row key={i}>
                      {row.cells.map((cell) => {
                        return (
                          <Table.Cell textAlign='center' {...cell.getCellProps()} className='commercial-fixed-cell'>
                            <div className='commercial-fixed-cell-overflow'>
                              {cell.render('Cell')}
                            </div>
                          </Table.Cell>
                        );
                      })}
                    </Table.Row>
                  );
                }

                let backgroundColor = 'white';
                if (status === 'REVISIÓN') {
                  backgroundColor = '#d1e4ff';
                }
                if (status === 'ALERTA') {
                  backgroundColor = '#fed9d9';
                }
                if (status === 'SEGUIMIENTO') {
                  backgroundColor = '#fff3cd';
                }
                return (
                  <Table.Row key={i} {...row.getRowProps({
                    'style': {backgroundColor},
                  })}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign='center' {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <div className='flex middle center mt-1'>
        {page.length > 0 && (
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan='5' textAlign='left'>
                <Button
                  className='navigation-button'
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                  content='Anterior'
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='right'>
                <span>páginas </span>
                <span>
                  <Input
                    className='pages-input'
                    type='number'
                    value={pageIndex + 1}
                    min='1'
                    max={pageOptions.length}
                    onChange={(e, {value}) => {
                      const page = value ? Number(value) - 1 : 0;
                      if (page < 1 || page > pageOptions.length) {
                        e.target.value = 1;
                      }
                      gotoPage(page);
                    }}
                  />
                </span>{' '}
                <span>de {pageOptions.length}</span>
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='left'>
                <Dropdown
                  className='page-sizes-selection'
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={invoicesPageSizes}
                  onChange={(e, {value}) => {
                    setPageSize(Number(value));
                  }}
                />
                <span>filas</span>
              </Table.HeaderCell>
              <Table.HeaderCell colSpan='4' textAlign='right'>
                <Button
                  className='navigation-button'
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                  content='Siguiente'
                />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </div>
    </>
  );
};

export default EtaManagementTable;
